import React from 'react'
import CopyLabel from '../copy/CopyDefinitions'
import Icon from './Icons'

class MiddlePhone extends React.Component{

  render() {   

    return(  
      <div className='middlePhone'>
        <div className='middlePhone-starsRow'>
          <Icon iconName='review-star'/>
          <Icon iconName='review-star'/>
          <Icon iconName='review-star'/>
          <Icon iconName='review-star'/>
          <Icon iconName='review-star'/>
        </div>
        {this.props.mobileOS === 'Android' && 
          <CopyLabel label='phoneStatsAndroid' />
        }
        {this.props.mobileOS === 'iPhone' && 
          <CopyLabel label='phoneStatsiOS' />
        }
      </div>
    )
  }
}

export default MiddlePhone
